import { jsxs as i, Fragment as s, jsx as n } from "react/jsx-runtime";
import _ from "classnames";
import { ICONS_BY_TYPE as f } from "./constants.js";
import { createElement as l } from "react";
import v from "../icon/Icon.js";
import '../../assets/Banner.css';const g = "_container_137mf_2", p = "_content_137mf_11", d = "_positive_137mf_24", u = "_informative_137mf_28", N = "_warning_137mf_32", b = "_blocking_137mf_36", k = "_neutral_137mf_40", t = {
  container: g,
  content: p,
  positive: d,
  informative: u,
  warning: N,
  blocking: b,
  neutral: k
}, E = ({ children: o, title: r, type: e = "neutral", className: c, as: a = "div", icon: m }) => l(
  a,
  { className: _(t.container, t[e], c) },
  /* @__PURE__ */ i(s, { children: [
    /* @__PURE__ */ n(v, { name: m || f[e] }),
    /* @__PURE__ */ i("div", { className: t.content, children: [
      !!r && /* @__PURE__ */ n("strong", { children: r }),
      !!o && /* @__PURE__ */ n("div", { children: o })
    ] })
  ] })
);
export {
  E as default
};
